import { NavigateFunction } from "react-router-dom";

import {
  archiveModalVar,
  attetionModalVar,
  createCopyModalVar,
  eventStatusModalVar,
  resumeTicketsSaleModalVar,
  stopTicketsSaleModalVar,
} from "../../../../graphql/globalVar/state";

export const handleStopTicketsSale = (eventId: number) => {
  eventStatusModalVar(null);
  stopTicketsSaleModalVar(eventId);
};

export const handleResumeTicketsSale = (eventId: number) => {
  eventStatusModalVar(null);
  resumeTicketsSaleModalVar(eventId);
};

export const handleMoveToArchive = (eventId: number) => {
  eventStatusModalVar(null);
  archiveModalVar(eventId);
};

export const handleEditEvent = (
  eventId: number,
  locale: string,
  navigate: NavigateFunction
) => {
  eventStatusModalVar(null);
  navigate(`${locale}/create-event/${eventId}/edit`);
};

export const handleCreateCopy = (eventId: number) => {
  eventStatusModalVar(null);
  createCopyModalVar(eventId);
};

export const handlePublishEvent = (eventId: string) => {
  eventStatusModalVar(null);
  attetionModalVar(eventId);
};
